"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const signalsKinds_1 = require("../../../data/constants/signalsKinds");
const Spectrum1D_1 = require("../../../data/data1d/Spectrum1D");
const ChartContext_1 = require("../../context/ChartContext");
const scale_1 = require("../utilities/scale");
const lineStyle = (0, react_1.css) `
  stroke: lightgrey;
  opacity: 0.7;
`;
function IndicationLines({ axis, show }) {
    const { data, view: { spectra: { activeTab }, }, xDomain, yDomain, displayerMode, } = (0, ChartContext_1.useChartData)();
    const [deltas1D, setDeltas1D] = (0, react_2.useState)([]);
    const scaleX = (0, scale_1.useScale2DX)();
    const scaleY = (0, scale_1.useScale2DY)();
    (0, react_2.useEffect)(() => {
        const split = activeTab.split(',');
        const nucleus = axis === 'X' ? split[0] : axis === 'Y' ? split[1] : null;
        if (nucleus !== null) {
            const ranges = data
                .filter((_datum) => _datum.display.isVisible && _datum.info.nucleus === nucleus)
                .filter((element) => (0, Spectrum1D_1.isSpectrum1D)(element))
                .flatMap((_datum) => _datum.ranges.values);
            const deltas = ranges.flatMap((_range) => _range.signals
                .filter((_signal) => signalsKinds_1.SIGNAL_INLCUDED_KINDS.includes(_signal.kind))
                .map((_signal) => _signal.delta));
            setDeltas1D(deltas);
        }
        else {
            setDeltas1D([]);
        }
    }, [activeTab, axis, data, displayerMode]);
    if (!show || !deltas1D?.length)
        return null;
    return ((0, jsx_runtime_1.jsx)("g", { children: deltas1D.map((_delta, i) => {
            if (axis === 'X') {
                return ((0, jsx_runtime_1.jsx)("line", { css: lineStyle, x1: scaleX(_delta), x2: scaleX(_delta), y1: scaleY(yDomain[0]), y2: scaleY(yDomain[1]) }, `indicationLine${axis}${i}`));
            }
            else {
                return ((0, jsx_runtime_1.jsx)("line", { css: lineStyle, x1: scaleX(xDomain[0]), x2: scaleX(xDomain[1]), y1: scaleY(_delta), y2: scaleY(_delta) }, `indicationLine${axis}${i}`));
            }
        }) }));
}
exports.default = IndicationLines;
